import './TicketProcessBuy.scss';
import Button from "react-bootstrap/Button";
import React from "react";
import InputGroup from 'react-bootstrap/InputGroup';
import Form from "react-bootstrap/Form";
import DatePicker from "react-datepicker";
import {Badge, ButtonGroup} from "react-bootstrap";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

import {DateRange} from 'react-date-range';
import {addDays, addMinutes, addMonths, addYears, isBefore, subYears, format, parse} from 'date-fns';

import {it} from "date-fns/locale";

import 'react-date-range/dist/styles.css'; // main css file
import 'react-date-range/dist/theme/default.css';
import data from "bootstrap/js/src/dom/data";
import Alert from "react-bootstrap/Alert"; // theme css file

const TicketProcessBuy = ({ticket}) => {
    console.log("TicketProcessBuy");
    console.log(ticket);

    const [step, setStep] = React.useState("quantity");
    const [quantity, setQuantity] = React.useState(1);
    const [index, setIndex] = React.useState(1);
    const [cart, setCart] = React.useState([]);
    const [currentTicket, setCurrentTicket] = React.useState({
        date_start: "",
        date_end: "",
        nickname: "",
        extra_data: []
    });

    const [dateCalendar, setDateCalendar] = React.useState([
        {
            startDate: null,
            endDate: new Date(""),
            key: 'selection',
            color: "rgb(81, 178, 112)"
        }
    ]);

    const nextStep = () => {
        if (step === "quantity") {
            setStep("setDate");
            setIndex(1);
            setCurrentTicket({date_start: "", date_end: "", nickname: "", extra_data: []});
        } else {
            if (step === "setDate") {
                setStep("setNickname");
            }
            if (step === "setNickname") {
                if (Object.keys(ticket.extra_data).length > 0) {
                    setStep("setExtraData");
                } else {
                    cart.push(currentTicket);
                    setCart(cart);
                    if (index < quantity) {
                        setStep("setDate");
                        setIndex(index + 1);
                        setCurrentTicket({date_start: "", date_end: "", nickname: "", extra_data: []});
                        setDateCalendar([
                            {
                                startDate: null,
                                endDate: new Date(""),
                                key: 'selection',
                                color: "rgb(81, 178, 112)"
                            }
                        ]);
                    } else {
                        setStep("summary");
                    }
                }
            }
            if (step === "setExtraData") {
                cart.push(currentTicket);
                setCart(cart);
                if (index < quantity) {
                    setStep("setDate");
                    setIndex(index + 1);
                    setCurrentTicket({date_start: "", date_end: "", nickname: "", extra_data: []});
                    setDateCalendar([
                        {
                            startDate: null,
                            endDate: new Date(""),
                            key: 'selection',
                            color: "rgb(81, 178, 112)"
                        }
                    ]);
                } else {
                    setStep("summary");
                }
            }
        }
    }

    const backStep = () => {
        if (step === "summary") {
            setIndex(Object.keys(cart).length + 1);
            setCurrentTicket(cart[Object.keys(cart).length]);
            if (Object.keys(ticket.extra_data).length > 0) {
                setStep("setExtraData");
            } else {
                setStep("setNickname");
            }

        }

        if (step === "setDate" && index === 1) {
            setStep("quantity");
            setCurrentTicket({date_start: "", date_end: "", nickname: "", extra_data: []});
        } else {
            if (step === "setNickname") {
                setStep("setDate");
                setCurrentTicket({...currentTicket, nickname: ""});
                setDateCalendar([
                    {
                        startDate: null,
                        endDate: new Date(""),
                        key: 'selection',
                        color: "rgb(81, 178, 112)"
                    }
                ]);
            }
            if (step === "setDate") {
                setIndex(index - 1);
                setCurrentTicket(cart[index - 1]);
                if (Object.keys(ticket.extra_data).length > 0) {
                    setStep("setExtraData");
                } else {
                    setStep("setNickname");
                }
            }
            if (step === "setExtraData") {
                setStep("setNickname");
            }

        }
    }


    function handleSelectDate(date) {
        let save = {
            startDate: date.selection.startDate,
            endDate: getDateEnd(ticket, date.selection.startDate),
            key: 'selection',
            color: "rgb(81, 178, 112)"
        }
        setDateCalendar([save]);
        setCurrentTicket({
            ...currentTicket,
            date_start: format(date.selection.startDate, "dd/MM/yyyy"),
            date_end: format(date.selection.endDate, "dd/MM/yyyy")
        });
    }

    function handleChangeExtraData(id, value) {
        let extra_data = currentTicket.extra_data;
        let found = false;
        for (let i in extra_data) {
            if (extra_data[i].id === id) {
                extra_data[i].value = value;
                found = true;
            }
        }
        if (!found)
            extra_data.push({id: id, value: value});
        setCurrentTicket({...currentTicket, extra_data: extra_data});
    }

    const getContent = () => {
        let content = [];
        switch (step) {
            case "quantity":
                content.push(<div className={"step-quantity"}>
                    <h4>Quanti ticket vuoi acquistare?</h4>
                    <hr/>
                    <InputGroup className="mb-3">
                        <Button variant="danger" onClick={() => setQuantity(quantity - 1)}>
                            Rimuovi
                        </Button>
                        <Form.Control
                            aria-label="Quantità"
                            aria-describedby="basic-addon1"
                            placeholder="Quantità"
                            type="number"
                            value={quantity}
                            onChange={(e) => setQuantity(e.target.value)}
                        />
                        <Button variant="success" onClick={() => setQuantity(quantity + 1)}>
                            Aggiungi
                        </Button>
                    </InputGroup>
                    <Button variant="success" onClick={() => nextStep()}>
                        Conferma
                    </Button>
                </div>);
                break;
            case "setDate":
                let date_start = dateCalendar[0].startDate;

                let date_content = <div className={"mt-3"}></div>;
                if (date_start !== null) {
                    if (date_start === dateCalendar[0].endDate) {
                        date_content = <p>Il ticket sarà valido il giorno <Badge
                            bg="success">{format(date_start, "dd/MM/yyyy")}</Badge></p>;
                    } else {
                        date_content = <p>La validità del ticket partirà dal giorno <Badge
                            bg="success">{format(date_start, "dd/MM/yyyy")}</Badge> al <Badge
                            bg="success">{format(dateCalendar[0].endDate, "dd/MM/yyyy")}</Badge></p>
                    }
                }
                console.log("ticket");
                console.log(ticket);
                let min_date = parse(ticket.date_start_validity, "dd/MM/yyyy", new Date());

                if (new Date() > min_date)
                    min_date = new Date();
                let max_date = parse(ticket.date_end_validity, "dd/MM/yyyy", new Date());
                console.log(min_date);
                console.log(max_date);
                console.log(max_date);
                content.push(<div className={"step-date"}>
                    <Badge bg={"dark"} className={"ticket-number"}>Ticket n°{index}</Badge>
                    <hr/>
                    <h4>Per quando ti serve il ticket?</h4>
                    <DateRange
                        locale={it} // Assicurati di passare la lingua
                        moveRangeOnFirstSelection={false}
                        minDate={min_date}
                        maxDate={max_date}
                        ranges={dateCalendar}
                        // ranges={state.length > 0 ? state : undefined}
                        // onChange={item => setState([item.selection])}
                        onChange={handleSelectDate}
                    />
                    {date_content}

                    <ButtonGroup aria-label="Basic example">
                        <Button variant="light" className={"mt-1"} onClick={() => backStep()}>
                            Indietro
                        </Button>
                        <Button variant="success" onClick={() => nextStep()} disabled={date_start === null}>
                            Continua
                        </Button>
                    </ButtonGroup>
                </div>);

                break;
            case "setNickname":
                content.push(<div className={"step-date"}>
                    <Badge bg={"dark"} className={"ticket-number"}>Ticket n°{index}</Badge>
                    <h4>Imposta il nominativo per questo ticket</h4>
                    <hr/>
                    <Form>
                        <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                            <Form.Label>Nominativo sul ticket</Form.Label>
                            <Form.Control type="text" placeholder="Nominativo" defaultValue={currentTicket.nickname}
                                          onChange={(e) => {
                                              setCurrentTicket({...currentTicket, nickname: e.target.value});

                                          }}/>
                        </Form.Group>
                    </Form>
                    <ButtonGroup aria-label="Basic example">
                        <Button variant="light" className={"mt-1"} onClick={() => backStep()}>
                            Indietro
                        </Button>
                        <Button variant="success" onClick={() => nextStep()}
                                disabled={currentTicket.nickname.trim() === "" ? "disabled" : ""}>
                            Continua
                        </Button>
                    </ButtonGroup>
                </div>);

                break;

            case "setExtraData":
                let extraDataContent = [];
                let can_continue = true;
                for (let data of ticket.extra_data) {
                    let currentValue = null;
                    if (currentTicket.extra_data.find((item) => item.id === data.id) !== undefined) {
                        currentValue = currentTicket.extra_data.find((item) => item.id === data.id).value;
                    }
                    if (data.is_required && (currentValue === null || currentValue.trim() === "")) {
                        can_continue = false;
                    }

                    let required_text = data.is_required ? <></> : <small>(non obbligatorio)</small>;
                    switch (data.type) {
                        case "DATE":

                            extraDataContent.push(
                                <Form.Group className="mb-3">
                                    <Form.Label>{data.name} {required_text}</Form.Label><br/>
                                    <DatePicker className="form-control"
                                                onChange={(date) => handleChangeExtraData(data.id, format(date, "dd/MM/yyyy"))}
                                                placeholderText={data.name}
                                                id={`extra-${data.id}`}
                                                value={currentValue}
                                    />
                                </Form.Group>
                            );
                            break;

                        case "STRING":
                            extraDataContent.push(
                                <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                    <Form.Label>{data.name} {required_text}</Form.Label>
                                    <Form.Control type="text" placeholder={data.name} value={currentValue}
                                                  id={`extra-${data.id}`}
                                                  onChange={(e) => {
                                                      handleChangeExtraData(data.id, e.target.value)
                                                  }}/>
                                </Form.Group>
                            )
                            break;

                        case "CHECKBOX":
                            extraDataContent.push(
                                <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                    <Form.Label>{data.name} {required_text}</Form.Label>
                                    <Form.Check // prettier-ignore
                                        type={"checkbox"}
                                        id={`extra-${data.id}`}
                                        label={data.name}
                                        onChange={(e) => {
                                            handleChangeExtraData(data.id, e.target.value)
                                        }}
                                    />
                                </Form.Group>
                            )
                            break;

                        case "SELECT":
                            extraDataContent.push(
                                <select className="form-select custom-select"
                                        id={`extra-${data.id}`}
                                        onChange={e => {
                                            handleChangeExtraData(data.id, e.target.value)
                                        }}>
                                    <option selected value={""}>Seleziona valore</option>
                                    {data.options.map((option) => (
                                        <option value={option}>{option}</option>))}
                                </select>
                            )
                            break;
                    }
                    if (typeof data.link !== "undefined" && data.link !== null)
                        extraDataContent.push(<a href={data.link}>{data.link}</a>);

                }


                content.push(<div className={"step-summary"}>
                    <h4>Campi aggiuntivi</h4>
                    <hr/>
                    {extraDataContent}
                    <ButtonGroup aria-label="Basic example">
                        <Button variant="light" className={"mt-1"} onClick={() => backStep()}>
                            Indietro
                        </Button>
                        <Button variant="success" onClick={() => nextStep()}
                                disabled={!can_continue ? "disabled" : ""}>
                            Continua
                        </Button>
                    </ButtonGroup>

                </div>);

                break;
            case "summary":
                let rows = [];
                let summary = [];


                if (Object.keys(cart).length === 0) {
                    rows.push(<Alert variant="warning">Non ci sono ticket nel carrello</Alert>)
                } else {
                    for (let obj of cart) {
                        rows.push(
                            <div key={obj.id} className={"summary-ticket"}>
                                <Badge bg={"success"}>Ticket n°{cart.indexOf(obj) + 1}</Badge>
                                <span>Nominativo: <b>{obj.nickname}</b></span>
                                <span>Data inizio del ticket: <b>{obj.date_start}</b></span>
                                <span>Data fine del ticket: <b>{obj.date_start}</b></span>
                            </div>
                        )
                    }
                    let total_tickets = (ticket.price * Object.keys(cart).length);
                    let total_commissions = ticket.service_fee;
                    if (ticket.multipliable_service_fee)
                        total_commissions = ticket.service_fee * Object.keys(cart).length;

                    summary = <div className="summary-ticket">
                        <span>Totale ticket: <b>{total_tickets.toFixed(2)}€</b></span>
                        <span>Commissioni: <b>{total_commissions.toFixed(2)}€</b></span>
                        <span>Totale: <b>{(total_tickets + total_commissions).toFixed(2)}€</b></span>
                        <a><small>Hai un codice sconto? Clicca qui per applicarlo</small></a>
                    </div>


                }

                content.push(<div className={"step-summary"}>
                    <h4>Riepilogo ordine</h4>
                    <hr/>
                    {rows}
                    {summary}
                    <div>
                        <Button variant="success" className={"m-2"} onClick={() => nextStep()}>
                            Paga con PayPal
                        </Button>
                        <Button variant="success" className={"m-2"} onClick={() => nextStep()}>
                            Paga con Stripe
                        </Button>
                    </div>
                    <Button variant="light" className={"mt-1"} onClick={() => backStep()}>
                        Indietro
                    </Button>
                </div>)
                break;
        }
        return content;
    }

    return (
        <div className="ticket-buy-container">
            {getContent()}
        </div>
    );
};

function getDateEnd(ticket, date) {
    let date_end = date;
    switch (ticket.type) {
        case "HOURLY":
            /*            setDataDatePicker((prev) => ({
                            ...prev,
                            includeTimes: formatCalendarIncludedTimes(
                                dataDatePicker.calendar,
                                date,
                                'open'
                            ),
                            startDate: isBefore(new Date(), date) === true ? null : date,
                            endDate: addMinutes(date, timeIntervals)
                        }));*/
            return;
        // case "DAILY":
        // setDataDatePicker((prev) => ({ ...prev, startDate: date, endDate: date }));
        // return;
        case "TWODAYS":
            date_end = addDays(date, 1);
            break;
        case "THREEDAYS":
            date_end = addDays(date, 2);
            break;
        case "FOURDAYS":
            date_end = addDays(date, 3);
            break;
        case "WEEKDAYS":
            date_end = addDays(date, 4);
            break;
        case "WEEKLY":
            date_end = addDays(date, 6);
            break;
        case "TWOWEEKS":
            date_end = addDays(date, 13);
            break;
        case "MONTHLY":
            date_end = addMonths(date, 1);
            break;
        case "TRIMESTER":
            date_end = addMonths(date, 2);
            break;
        case "SEASONAL":
        case "SEMIANNUAL":
            date_end = addMonths(date, 6);
            break;
        case "YEARLY":
            date_end = addYears(date, 1);
            break;
        case "BIANNUAL":
            date_end = subYears(date, 2);
            break;
        case "TRIENNIAL":
            date_end = addYears(date, 3);
            break;
    }
    if (date_end > parse(ticket.date_end_validity, "dd/MM/yyyy", new Date()))
        date_end = parse(ticket.date_end_validity, "dd/MM/yyyy", new Date());

    return date_end;
}

export default TicketProcessBuy;
